import dynamic from 'next/dynamic';
import { ROUTES } from '../common/constants';
import CustomAnchor from '../components/CustomAnchor';

const SiteUrl = dynamic(() => import('../components/SiteUrl'), {
  loading: () => null,
  ssr: false
});

function TermsAndConditions() {
  return (
    <section>
      <div className="cms-pages ">
        <div className="container">
          <h1 className="display-h1 text-center">Terms & Conditions</h1>
          <h2 className="heading-h1">Terms & Conditions</h2>
          <strong className="label-l">Last updated: May 13, 2019</strong>
          <p>
            Welcome to Breitbart! We are pleased to provide the services
            described below for your education and entertainment in accordance
            with these Terms of Use (”Terms”).
          </p>
          <p>
            Please read these Terms of Use (”Terms”, ”Terms of Use”) carefully
            before using the <SiteUrl /> website (the ”Service”) operated by The
            Relevate Group (”us”, ”we”, or ”our” or “Q”).
          </p>
          <p>
            Your access to and use of the Service is conditioned upon your
            acceptance of and compliance with these Terms. These Terms apply to
            all visitors, users and others who wish to access or use the
            Service.
          </p>
          <p>
            By accessing or using the Service you agree to be bound by these
            Terms. If you disagree with any part of the terms then you do not
            have permission to access the Service.
          </p>
          <h2 className="heading-h1">Use of service</h2>
          <p>
            You agree to use the Breitbart service, including all features and
            functionalities associated therewith, in accordance with all
            applicable laws, rules and regulations, or other restrictions on use
            of the service or content therein. You agree not to archive,
            reproduce, distribute, modify, display, perform, publish, license,
            create derivative works from, offer for sale, or use (except as
            explicitly authorized in these Terms of Use) content and information
            contained on or obtained from or through the Breitbart service.
          </p>
          <p>
            You also agree not to: circumvent, remove, alter, deactivate,
            degrade or thwart any of the content protections in the Video
            Service service; use any robot, spider, scraper or other automated
            means to access the Breitbart service; decompile, reverse engineer
            or disassemble any software or other products or processes
            accessible through the Breitbart service; insert any code or product
            or manipulate the content of the Breitbart service in any way; or
            use any data mining, data gathering or extraction method.
          </p>
          <p>
            In addition, you agree not to upload, post, e-mail or otherwise send
            or transmit any material designed to interrupt, destroy or limit the
            functionality of any computer software or hardware or
            telecommunications equipment associated with the Breitbart service,
            including any software viruses or any other computer code, files or
            programs. We may terminate or restrict your use of our service if
            you violate these Terms of Use or are engaged in illegal or
            fraudulent use of the service.
          </p>
          <h2 className="heading-h1">Purchases</h2>
          <p>
            If you wish to purchase any product or service made available
            through the Service (”Purchase”), you may be asked to supply certain
            information relevant to your Purchase including, without limitation,
            your credit card number, the expiration date of your credit card,
            your billing address, and your shipping information.
          </p>
          <p>
            You represent and warrant that: (i) you have the legal right to use
            any credit card(s) or other payment method(s) in connection with any
            Purchase; and that (ii) the information you supply to us is true,
            correct and complete.
          </p>
          <p>
            The service may employ the use of third party services for the
            purpose of facilitating payment and the completion of Purchases. By
            submitting your information, you grant us the right to provide the
            information to these third parties subject to our Privacy Policy.
          </p>
          <p>
            We reserve the right to refuse or cancel your order at any time for
            reasons including but not limited to: product or service
            availability, errors in the description or price of the product or
            service, error in your order or other reasons.
          </p>
          <p>
            We reserve the right to refuse or cancel your order if fraud or an
            unauthorized or illegal transaction is suspected.
          </p>
          <h2 className="heading-h1">Availability, Errors and Inaccuracies</h2>
          <p>
            We are constantly updating product and service offerings on the
            Service. We may experience delays in updating information on the
            Service and in our advertising on other web sites. The information
            found on the Service may contain errors or inaccuracies and may not
            be complete or current. Products or services may be mispriced,
            described inaccurately, or unavailable on the Service and we cannot
            guarantee the accuracy or completeness of any information found on
            the Service.
          </p>
          <p>
            We therefore reserve the right to change or update information and
            to correct errors, inaccuracies, or omissions at any time without
            prior notice.
          </p>
          <h2 className="heading-h1">Billing and Cancellation</h2>
          <p>
            Some parts of the Service are billed on a subscription basis
            (”Subscription(s)”). You will be billed in advance on a recurring
            and periodic basis (”Billing Cycle”). Billing cycles are set either
            on a monthly or annual basis, depending on the type of subscription
            plan you select when purchasing a Subscription.
          </p>
          <p>
            At the end of each Billing Cycle, your Subscription will
            automatically renew under the exact same conditions unless you
            cancel it or Q cancels it. You may cancel your Subscription renewal
            by contacting Q’s customer support team.
          </p>
          <p>
            A valid payment method, including credit card, is required to
            process the payment for your Subscription. You shall provide Q with
            accurate and complete billing information a valid payment method
            information. By submitting such payment information, you
            automatically authorize Q to charge all Subscription fees incurred
            through your account to any such payment instruments.
          </p>
          <p>
            Should automatic billing fail to occur for any reason, Q will issue
            an electronic invoice indicating that you must proceed manually,
            within a certain deadline date, with the full payment corresponding
            to the billing period as indicated on the invoice.
          </p>
          <p>
            You can cancel your Breitbart subscription at any time, and you will
            continue to have access to the Breitbart service until Q cancels
            your service. To the extent permitted by the applicable law,
            payments are non-refundable and we do not provide refunds or credits
            for any partial-month membership periods or unwatched Q content. To
            cancel, contact Q through the Contact Us page.
          </p>
          <h2 className="heading-h1">Free Trial</h2>
          <p>
            Q may, at its sole discretion, offer a Subscription with a free
            trial for a limited period of time (”Free Trial”).
          </p>
          <p>
            You may be required to enter your billing information in order to
            sign up for the Free Trial.
          </p>
          <p>
            If you do enter your billing information when signing up for the
            Free Trial, you will not be charged by Q until the Free Trial has
            expired. On the last day of the Free Trial period, unless you
            cancelled your Subscription, you will be automatically charged the
            applicable Subscription fees for the type of Subscription you have
            selected.
          </p>
          <p>
            At any time and without notice, Q reserves the right to (i) modify
            the terms and conditions of the Free Trial offer, or (ii) cancel
            such Free Trial offer.
          </p>
          <h2 className="heading-h1">Fee Changes</h2>
          <p>
            Q, in its sole discretion and at any time, may modify the
            Subscription fees for the Subscriptions. Any Subscription fee change
            will become effective at the end of the then-current Billing Cycle.
          </p>
          <p>
            Q will provide you with a reasonable prior notice of any change in
            Subscription fees to give you an opportunity to terminate your
            Subscription before such change becomes effective.
          </p>
          <p>
            Your continued use of the Service after the Subscription fee change
            comes into effect constitutes your agreement to pay the modified
            Subscription fee amount.
          </p>
          <h2 className="heading-h1">Refunds</h2>
          <p>
            Except when required by law, paid Subscription fees are
            non-refundable.
          </p>
          <h2 className="heading-h1">Accounts</h2>
          <p>
            When you create an account with us, you guarantee that you are above
            the age of 18, and that the information you provide us is accurate,
            complete, and current at all times. Inaccurate, incomplete, or
            obsolete information may result in the immediate termination of your
            account on the Service.
          </p>
          <p>
            You are responsible for maintaining the confidentiality of your
            account and password, including but not limited to the restriction
            of access to your computer and/or account. You agree to accept
            responsibility for any and all activities or actions that occur
            under your account and/or password, whether your password is with
            our Service or a third-party service. You must notify us immediately
            upon becoming aware of any breach of security or unauthorized use of
            your account.
          </p>
          <p>
            Your Breitbart account is for your individual use only, or the
            individual use of those users that are linked to your account
            through the set number of login IDs provided by Q for Teams and
            Churches. It is not permissible for you to use your Breitbart access
            to share the content with others. You agree to not use the content
            for public gatherings.
          </p>
          <p>
            We reserve the right to refuse service, terminate accounts, remove
            or edit content, or cancel orders in our sole discretion.
          </p>
          <h2 className="heading-h1">Intellectual Property</h2>
          <p>
            The Service and its original content, features and functionality are
            and will remain the exclusive property of Q and its licensors. The
            Service is protected by copyright, trademark, and other laws of both
            the United States and foreign countries. Our trademarks and trade
            dress may not be used in connection with any product or service
            without the prior written consent of Q.
          </p>
          <h2 className="heading-h1">Links To Other Web Sites</h2>
          <p>
            Our Service may contain links to third party web sites or services
            that are not owned or controlled by Q.
          </p>
          <p>
            Q has no control over, and assumes no responsibility for the
            content, privacy policies, or practices of any third party web sites
            or services. We do not warrant the offerings of any of these
            entities/individuals or their websites.
          </p>
          <p>
            You acknowledge and agree that Q shall not be responsible or liable,
            directly or indirectly, for any damage or loss caused or alleged to
            be caused by or in connection with use of or reliance on any such
            content, goods or services available on or through any such third
            party web sites or services.
          </p>
          <p>
            We strongly advise you to read the terms and conditions and privacy
            policies of any third party web sites or services that you visit.
          </p>
          <h2 className="heading-h1">Termination</h2>
          <p>
            We may terminate or suspend your account and bar access to the
            Service immediately, without prior notice or liability, under our
            sole discretion, for any reason whatsoever and without limitation,
            including but not limited to a breach of the Terms.
          </p>
          <p>
            If you wish to terminate your account, you may simply discontinue
            using the Service.
          </p>
          <p>
            All provisions of the Terms which by their nature should survive
            termination shall survive termination, including, without
            limitation, ownership provisions, warranty disclaimers, indemnity
            and limitations of liability.
          </p>

          <h2 className="heading-h1">Indemnification</h2>
          <p>
            You agree to defend, indemnify and hold harmless The Relevate Group
            and its licensee and licensors, and their employees, contractors,
            agents, officers and directors, from and against any and all claims,
            damages, obligations, losses, liabilities, costs or debt, and
            expenses (including but not limited to attorney’s fees), resulting
            from or arising out of a) your use and access of the Service, by you
            or any person using your account and password, or b) a breach of
            these Terms.
          </p>
          <h2 className="heading-h1">Limitation Of Liability</h2>
          <p>
            In no event shall The Relevate Group, nor its directors, employees,
            partners, agents, suppliers, or affiliates, be liable for any
            indirect, incidental, special, consequential or punitive damages,
            including without limitation, loss of profits, data, use, goodwill,
            or other intangible losses, resulting from (i) your access to or use
            of or inability to access or use the Service; (ii) any conduct or
            content of any third party on the Service; (iii) any content
            obtained from the Service; and (iv) unauthorized access, use or
            alteration of your transmissions or content, whether based on
            warranty, contract, tort (including negligence) or any other legal
            theory, whether or not we have been informed of the possibility of
            such damage, and even if a remedy set forth herein is found to have
            failed of its essential purpose.
          </p>
          <h2 className="heading-h1">Disclaimer</h2>
          <p>
            Your use of the Service is at your sole risk. The Service is
            provided on an ”AS IS” and ”AS AVAILABLE” basis. The Service is
            provided without warranties of any kind, whether express or implied,
            including, but not limited to, implied warranties of
            merchantability, fitness for a particular purpose, non-infringement
            or course of performance.
          </p>
          <p>
            The Relevate Group its subsidiaries, affiliates, and its licensors
            do not warrant that a) the Service will function uninterrupted,
            secure or available at any particular time or location; b) any
            errors or defects will be corrected; c) the Service is free of
            viruses or other harmful components; or d) the results of using the
            Service will meet your requirements.
          </p>
          <h2 className="heading-h1">Exclusions</h2>
          <p>
            Some jurisdictions do not allow the exclusion of certain warranties
            or the exclusion or limitation of liability for consequential or
            incidental damages, so the limitations above may not apply to you.
          </p>
          <h2 className="heading-h1">Governing Law</h2>
          <p>
            These Terms shall be governed and construed in accordance with the
            laws of Tennessee, United States, without regard to its conflict of
            law provisions.
          </p>
          <p>
            Our failure to enforce any right or provision of these Terms will
            not be considered a waiver of those rights. If any provision of
            these Terms is held to be invalid or unenforceable by a court, the
            remaining provisions of these Terms will remain in effect. These
            Terms constitute the entire agreement between us regarding our
            Service, and supersede and replace any prior agreements we might
            have had between us regarding the Service.
          </p>
          <h2 className="heading-h1">Changes</h2>
          <p>
            We reserve the right, at our sole discretion, to modify or replace
            these Terms at any time. If a revision is material we will provide
            at least 15 days notice prior to any new terms taking effect. What
            constitutes a material change will be determined at our sole
            discretion.
          </p>
          <p>
            By continuing to access or use our Service after any revisions
            become effective, you agree to be bound by the revised terms. If you
            do not agree to the new terms, you are no longer authorized to use
            the Service.
          </p>
          <h2 className="heading-h1">Contact Us</h2>
          <p>
            If you have any questions about these Terms, please{' '}
            <CustomAnchor href={ROUTES?.CONTACT}>contact us.</CustomAnchor>
          </p>
        </div>
      </div>
    </section>
  );
}
export default TermsAndConditions;
